/**
 * Email persistence from URL query parameter to checkout
 * Captures ?email= from URL, stores in sessionStorage (session-only for security), injects into cart forms and checkout links
 */
(function() {
  'use strict';

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function setStoredEmail(email) {
    try {
      if (email && email.trim() !== '') {
        sessionStorage.setItem('juno_user_email', email.trim());
      }
    } catch (e) {
      console.warn('Could not save email to sessionStorage:', e);
    }
  }

  function getStoredEmail() {
    try {
      return sessionStorage.getItem('juno_user_email');
    } catch (e) {
      console.warn('Could not read email from sessionStorage:', e);
      return null;
    }
  }

  function injectEmailIntoForms() {
    var storedEmail = getStoredEmail();
    if (!storedEmail) return;

    var forms = document.querySelectorAll('form[action*="/cart"], form[action*="/cart/add"]');

    forms.forEach(function(form) {
      var existingInput = form.querySelector('input[name="checkout[email]"]');
      if (existingInput) {
        existingInput.value = storedEmail;
      } else {
        var hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'checkout[email]';
        hiddenInput.value = storedEmail;
        form.appendChild(hiddenInput);
      }
    });
  }

  function updateCheckoutLinks() {
    var storedEmail = getStoredEmail();
    if (!storedEmail) return;

    var checkoutLinks = document.querySelectorAll('a[href="/checkout"], a[href*="/checkout"]');

    checkoutLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      if (href && href.indexOf('checkout[email]') === -1) {
        var separator = href.indexOf('?') !== -1 ? '&' : '?';
        var newHref = href + separator + 'checkout[email]=' + encodeURIComponent(storedEmail);
        link.setAttribute('href', newHref);
      }
    });
  }

  function initEmailPersistence() {
    var urlEmail = getUrlParameter('email');
    if (urlEmail) {
      setStoredEmail(urlEmail);
    }

    injectEmailIntoForms();
    updateCheckoutLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmailPersistence);
  } else {
    initEmailPersistence();
  }

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      var shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          shouldUpdate = true;
        }
      });
      if (shouldUpdate) {
        injectEmailIntoForms();
        updateCheckoutLinks();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    } else {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
})();
